import { topicTags } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            大家都在讨论的影视热点，看看有没有你感兴趣的
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {topicTags.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className={`whitespace-nowrap group inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer border ${
                topic.hot
                  ? 'bg-accent-50 text-accent-700 border-accent-200 hover:bg-accent-100'
                  : 'bg-background-100 text-foreground-700 border-background-200 hover:bg-background-200'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              )}
              <span>{topic.name}</span>
              <span className="text-xs opacity-60">{topic.count}</span>
            </a>
          ))}
        </div>

        <div className="flex justify-center mt-6">
          <a
            href="#index"
            className="whitespace-nowrap inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-500 font-medium transition-colors cursor-pointer"
          >
            查看全部话题
            <i className="ri-arrow-right-line text-xs"></i>
          </a>
        </div>
      </div>
    </section>
  );
}